import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ScrollAnimationDirective } from '../../directives/scroll-animation.directive';
import { MotionBackgroundComponent } from '../shared/motion-background.component';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-hero',
  standalone: true,
  imports: [
    MatButtonModule,
    ScrollAnimationDirective,
    MotionBackgroundComponent,
    RouterLink,
    CommonModule,
    TranslateModule
  ],
  template: `
    <header id="hero" class="section hero-section">
      <app-motion-background></app-motion-background>
      <div class="container">
        <div class="hero-content" scrollAnimation>
          <h1>{{ 'HERO.TITLE' | translate }}</h1>
          <p class="hero-subtitle">{{ 'HERO.SUBTITLE' | translate }}</p>
          <button mat-raised-button class="cta-button" [routerLink]="['/index/register']">
            {{ 'HERO.CTA' | translate }}
          </button>
        </div>
      </div>
    </header>
  `,
  styles: [`
    .hero-section {
      background: #6a1b9a;
      min-height: 60vh;
      display: flex;
      align-items: center;
      text-align: center;
      color: white;
      position: relative;
      overflow: hidden;
      margin-top:0;
      padding-top:0;
    }
    .cta-button {
      background: #e44891;
      color: #fff;
    }
    .hero-content {
      max-width: 800px;
      margin: 0 auto;
      position: relative;
      z-index: 1;
    }
    h1 {
      font-size: 2.75rem;
      margin-bottom: 1.5rem;
      line-height: 1.2;
      margin-top:0;
    }
    .hero-subtitle {
      font-size: 1.25rem;
      margin-bottom: 2rem;
      opacity: 0.9;
    }
    @media (max-width: 768px) {
      h1 {
        font-size: 2rem;
      }
      .hero-subtitle {
        font-size: 1.1rem;
      }
    }
  `]
})
export class HeroComponent {}
